module.exports = __webpack_public_path__ + "img/404.fea03645.png";